import React, { useEffect, useRef } from "react";
import { UserOutlined } from "@ant-design/icons";
import { Form, Button, Input } from "antd";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import UserIcon from "@src/styles/image/logo.png";
import {
  getAllowedDomains,
  getLoginRequest,
  initMsalOnce,
} from "../../redux/services/config";
import { useHistory } from "react-router-dom";
import "./login-email.scss";
import { useTranslation } from "react-i18next";
import { FullscreenSpinner } from "../../component/Util/FullscreenSpinner";

function LoginEmail() {
  const { t } = useTranslation();
  const { instance, accounts, inProgress } = useMsal();
  const history = useHistory();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (accounts?.length > 0) {
      const active = instance.getActiveAccount();
      if (!active) {
        instance.setActiveAccount(accounts[0]);
      }
      didRedirect.current = true;
      history.replace("/");
    }
  }, [accounts, instance, history]);

  const onFinish = async ({ email }) => {
    if (inProgress !== InteractionStatus.None) return;

    sessionStorage.clear();

    try {
      const msalConfig = initMsalOnce(email);

      const loginRequest = {
        ...getLoginRequest(),
        loginHint: email,
        prompt: "login"
      };

      await msalConfig.loginRedirect(loginRequest);
    } catch (e) {
      console.error("Login error", e);
    }
  };

  if (
    inProgress !== InteractionStatus.None ||
    (accounts && accounts.length > 0)
  ) {
    return <FullscreenSpinner tip="Loading..." />;
  }

  const validateEmailDomain = (_, value) => {
    const email = (value || "").trim();

    if (!email) {
      return Promise.reject(new Error(`${t("messages.emailRequire")}`));
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return Promise.reject(new Error(`${t("messages.emailInvalid")}`));
    }

    const allowedDomains = getAllowedDomains();
    const isAllowedDomain = allowedDomains.some((domain) =>
      email.toLowerCase().endsWith(`@${domain.toLowerCase()}`)
    );

    if (!isAllowedDomain) {
      return Promise.reject(new Error(`${t("messages.emailInvalid")}`));
    }

    return Promise.resolve();
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-bg" />
      </div>
      <div className="login-right">
        <div className="login-form-container">
          <img
            src={UserIcon}
            alt="Logo"
            style={{ maxWidth: "100%", marginBottom: 20 }}
          />
          <div className="login-form-title">AI流入水量予測システム</div>
          <Form name="login" layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="email"
              validateTrigger="onBlur"
              rules={[
                {
                  validator: validateEmailDomain,
                },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="メールアドレス"
                autoComplete="email"
              />
            </Form.Item>
            <Form.Item className="login-btn-container">
              <Button
                className="login-btn"
                type="primary"
                htmlType="submit"
                // disabled={disableButton}
              >
                サインイン
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default LoginEmail;
